export const IMAGE_SIZE = 24;
export const BORDER = true;
